
import React from 'react';
import './DesignSystemDemo.css';

const DesignSystemDemo = () => {
  return (
    <div className="demo-container">
      <header className="demo-header">
        <h1>Sumrise Design System Demo</h1>
        <p>Explore three modern directions for the future of sumrise.</p>
      </header>

      <section className="demo-section">
        <h2>1. The Focused Path (Minimalist & Calming)</h2>
        <div className="vibe-focused">
          <div className="focused-card">
            <h3>Solve the Equation</h3>
            <p>What is the value of $x$ when $2x + 5 = 15$?</p>
            <div className="progress-bar">
              <div className="progress-fill"></div>
            </div>
            <p style={{ fontSize: '0.8rem', color: '#64748b' }}>65% through current session</p>
            <button className="btn-focused">Submit Answer</button>
          </div>
        </div>
      </section>

      <section className="demo-section">
        <h2>2. The Interactive Lab (Tech-Forward & Sleek)</h2>
        <div className="vibe-lab">
          <div className="lab-card">
            <h3 style={{ margin: 0 }}>Advanced Mastery</h3>
            <p style={{ opacity: 0.7 }}>Level 4: Algebraic Fractions</p>
            <div style={{ display: 'flex', gap: '10px', marginTop: '20px' }}>
              <div style={{ flex: 1, height: '40px', background: 'rgba(255,255,255,0.1)', borderRadius: '8px' }}></div>
              <div style={{ flex: 1, height: '40px', background: 'rgba(255,255,255,0.1)', borderRadius: '8px' }}></div>
              <div style={{ flex: 1, height: '40px', background: 'rgba(255,255,255,0.1)', borderRadius: '8px' }}></div>
            </div>
            <button className="btn-lab" style={{ marginTop: '30px', width: '100%' }}>Launch Session</button>
          </div>
        </div>
      </section>

      <section className="demo-section">
        <h2>3. Modern Dashboard (Bento Layout)</h2>
        <div className="bento-grid">
          <div className="bento-item bento-1">
            <h3>Weekly Plan</h3>
            <p>Your journey to mastery</p>
          </div>
          <div className="bento-item bento-2">
            <h3>Recent Activity</h3>
          </div>
          <div className="bento-item bento-3 pulse-success">
            <h3>New Badge!</h3>
          </div>
          <div className="bento-item bento-4">
            <h3>Support</h3>
          </div>
        </div>
      </section>

      <section className="demo-section">
        <h2>Typography & UI Elements</h2>
        <div style={{ display: 'flex', gap: '40px', flexWrap: 'wrap' }}>
          <div>
            <h3>Headings</h3>
            <h1 style={{ fontSize: '3rem' }}>Display 1</h1>
            <h2>Heading 2</h2>
            <h3>Heading 3</h3>
          </div>
          <div>
            <h3>Status Indicators</h3>
            <div style={{ display: 'flex', gap: '10px' }}>
              <span style={{ padding: '4px 12px', background: '#dcfce7', color: '#166534', borderRadius: '20px', fontSize: '12px', fontWeight: 'bold' }}>MASTERED</span>
              <span style={{ padding: '4px 12px', background: '#fef9c3', color: '#854d0e', borderRadius: '20px', fontSize: '12px', fontWeight: 'bold' }}>IN PROGRESS</span>
              <span style={{ padding: '4px 12px', background: '#fee2e2', color: '#991b1b', borderRadius: '20px', fontSize: '12px', fontWeight: 'bold' }}>STUCK</span>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default DesignSystemDemo;
